import React, { Component } from 'react';
import { Button, Jumbotron, Modal, Pagination } from 'react-bootstrap';

import AssetItemList from './AssetItemList.js';
import CategoryAdd from './CategoryAdd.js';
import AssetChange from './AssetChange.js';

import './SettingsPage.css';

class AssetsPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            numAssets: 0,
            assetsTitle: 'Assets',
            showAssetStringPopup: false,
            assetStringInput: '',
            showUploadPopup: false,
            uploadMsg: '',
            showAddAsset: false,
            errMsg: '',
            updateAssetVisible: false,
            updateAsset: { assetId: -1, asset: '', colour: '' },
            startIndex: 0,
            pageId: 1,
            pageSize: 10
        };

        this.frmAddAsset = React.createRef();
    }

    componentDidMount() {
        fetch('asset_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=-1&pageCount=0"
        })
        .then(res => res.json())
        .then((data) => {
            this.setState({
                numAssets: data.length
            });
        })
        .catch(console.log)

        fetch('get_asset_string', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
        .then(res => res.json())
        .then((data) => {
            if (data && data[0] && data[0].value) {
                this.setState({ assetsTitle: data[0].value });
            }
        })
        .catch(console.log)
    }

    openAssetStringPopup = () => {
        this.setState({ showAssetStringPopup: true, assetStringInput: this.state.assetsTitle });
    }

    handleCloseAssetString = () => {
        this.setState({ showAssetStringPopup: false });
    }

    handleAssetStringChange = (event) => {
        this.setState({ assetStringInput: event.target.value });
    }

    handleSaveAssetString = (event) => {
        event.preventDefault();
        fetch('set_asset_string', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "value=" + encodeURIComponent(this.state.assetStringInput)
        })
        .then(res => res.json())
        .then(data => {
            if (data && data[0] && data[0].success === 'true') {
                this.setState({ assetsTitle: this.state.assetStringInput, showAssetStringPopup: false });
                if (this.props.reloadAssetString) {
                    this.props.reloadAssetString();
                }
            }
        })
        .catch(console.log)
    }

    renderAssetStringModal = () => {
        return (
            <Modal
            show={this.state.showAssetStringPopup}
            onHide={this.handleCloseAssetString}
            backdrop="static"
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 class="pageTitle">Asset Label</h1></center></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <input name="txtAssetString" type="text" value={this.state.assetStringInput} onChange={this.handleAssetStringChange} />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this.handleSaveAssetString}>Save</Button>
                <Button onClick={this.handleCloseAssetString}>Close</Button>
            </Modal.Footer>
            </Modal>
        );
    }

    reloadAssets = () => {
        fetch('asset_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=-1&pageCount=0"
        })
        .then(res => res.json())
        .then((data) => {
            this.setState({
                numAssets: data.length
            });
        })
        .catch(console.log)

        this.refs.assetlist.reloadList(this.state.startIndex, this.state.pageSize);
    }

    renderPagination = () => {
        let numPages = Math.max(1, Math.ceil(this.state.numAssets / this.state.pageSize));
        let items = [];
        let active = this.state.pageId;

        for (let number = 1; number <=numPages; number++)
        {
            items.push(
                <Pagination.Item className="pageEvents" key={number} active={number === active}>
                {number}
                </Pagination.Item>,
            );
        }

        return (
            <Pagination onClick={this.loadPage}>{items}</Pagination>
        )
    }

    loadPage = e => {
        if (typeof e.target.text !== "undefined")
        {
            let newPageId = parseInt(e.target.text);
            let newStartIndex = (newPageId-1) * this.state.pageSize;

            this.setState({
                pageId: newPageId,
                startIndex: newStartIndex
            });

            this.refs.assetlist.reloadList(newStartIndex, this.state.pageSize);
        }
    }

    handleDownloadCsv = () => {
        //navigating (rather than fetching) lets the servlet's Content-Disposition
        //attachment header drive the browser's download UI without leaving the page
        window.location.href = 'muster_point_export';
    }

    handleShowUpload = () => {
        this.setState({ showUploadPopup: true, uploadMsg: '' });
    }

    handleCloseUpload = () => {
        this.setState({ showUploadPopup: false });
    }

    uploadXlsxFile = (file) => {
        if (!file) {
            return;
        }

        this.setState({ uploadMsg: 'Uploading...' });

        const formData = new FormData();
        formData.append('file', file);

        fetch('muster_point_import', {
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(data => {
            if (data && data[0] && data[0].success === 'true') {
                this.setState({ uploadMsg: data[0].msg });
                this.reloadAssets();
            }
            else {
                this.setState({ uploadMsg: (data && data[0] && data[0].msg) || 'Upload failed' });
            }
        })
        .catch(() => {
            this.setState({ uploadMsg: 'Upload failed' });
        })
    }

    handleUploadFileSelected = (e) => {
        const file = e.target.files[0];
        e.target.value = '';    //so picking the same file again re-triggers onChange
        this.uploadXlsxFile(file);
    }

    handleUploadDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.uploadXlsxFile(e.dataTransfer.files[0]);
    }

    handleUploadDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    renderUploadModal = () => {
        return (
            <Modal
            show={this.state.showUploadPopup}
            onHide={this.handleCloseUpload}
            backdrop="static"
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 class="pageTitle">Upload XLSX</h1></center></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div
                    onDrop={this.handleUploadDrop}
                    onDragOver={this.handleUploadDragOver}
                    style={{ border: '2px dashed #282c34', borderRadius: '0.5rem', padding: '2rem', textAlign: 'center', marginBottom: '1rem' }}
                >
                    Drag &amp; drop an .xlsx file here
                </div>
                <center><input type="file" accept=".xlsx" onChange={this.handleUploadFileSelected} /></center>
            </Modal.Body>
            <Modal.Footer>
                <span className="userAddErr">{this.state.uploadMsg}</span>
                <Button onClick={this.handleCloseUpload}>Close</Button>
            </Modal.Footer>
            </Modal>
        );
    }

    handleAddAsset = () => {
        this.setState({
            showAddAsset: true,
            errMsg: ''
        });
    }

    handleCloseAsset = () => {
        this.setState({ showAddAsset: false });
    }

    showUpdateAsset = (asset) => {
        this.setState({ updateAsset: asset, updateAssetVisible: true });
    }

    hideUpdateAsset = () => {
        this.setState({ updateAssetVisible: false });
    }

    handleUpdateAssetChange = (e) => {
        let asset = this.state.updateAsset;
        asset.asset = e.target.value;
        this.setState({ updateAsset: asset });
    }

    handleUpdateColourChange = (e) => {
        let asset = this.state.updateAsset;
        asset.colour = e.target.value;
        this.setState({ updateAsset: asset });
    }

    handleSubmitAsset = () => {
        fetch('asset_add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "asset=" + this.frmAddAsset.current.GetTitle() + "&colour=" + this.frmAddAsset.current.GetColour()
        })
        .then(res => res.json())
        .then(data =>
        {
            if ('true' === data[0].add)
            {
                this.setState({
                    showAddAsset: false
                });

                this.reloadAssets();
            }
            else
            {
                this.setState({
                    errMsg: data[0].msg
                });
            }
        })
    }

    render() {
        const numAssets = this.state.numAssets;
        if (1 === this.props.accessLevel)
        {
            return (<div>

                <Modal
                show={this.state.showAddAsset}
                onHide={this.handleCloseAsset}
                backdrop="static"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title><center><h1 class="pageTitle">Add new {this.state.assetsTitle}</h1></center></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <CategoryAdd ref={this.frmAddAsset} reloadCategory={this.reloadAssets} />
                </Modal.Body>

                <Modal.Footer>
                    <span className="CategoryAddSpan">{this.state.errMsg}</span>
                    <Button onClick={this.handleSubmitAsset}>Add</Button>
                    <Button onClick={this.handleCloseAsset}>Close</Button>
                </Modal.Footer>
                </Modal>

                {this.renderAssetStringModal()}
                {this.renderUploadModal()}
                <Jumbotron className="jumboHeader">
                <center><h1 class="pageTitle" onClick={this.openAssetStringPopup} style={{ cursor: 'pointer' }}>{this.state.assetsTitle}</h1></center>
                <center><h2 class="pageTitle">{this.state.assetsTitle} Count: {numAssets}</h2></center>
                <center><Button onClick={this.handleDownloadCsv} className="btnCategory">Download XLSX</Button> <Button onClick={this.handleShowUpload} className="btnCategory">Upload XLSX</Button></center>
                </Jumbotron>
                <div class="paginationEvents">{this.renderPagination()}</div>
                <AssetChange
                    assetTitle={this.state.assetsTitle}
                    updateAssetVisible={this.state.updateAssetVisible}
                    hideUpdateAsset={this.hideUpdateAsset}
                    handleUpdateAssetChange={this.handleUpdateAssetChange}
                    handleUpdateColourChange={this.handleUpdateColourChange}
                    asset={this.state.updateAsset} />

                <AssetItemList accessLevel={this.props.accessLevel} reloadAssets={this.reloadAssets} showUpdateAsset={this.showUpdateAsset} ref="assetlist"/>
                <Button onClick={this.handleAddAsset} className="btnCategory">
                Add {this.state.assetsTitle}
                </Button>

                </div>
            )
        }
        else
        {
            return (<div>

                {this.renderAssetStringModal()}
                <Jumbotron className="jumboHeader">
                <center><h1 class="pageTitle" onClick={this.openAssetStringPopup} style={{ cursor: 'pointer' }}>{this.state.assetsTitle}</h1></center>
                <center><h2 class="pageTitle">{this.state.assetsTitle} Count: {numAssets}</h2></center>
                <center><Button onClick={this.handleDownloadCsv} className="btnCategory">Download XLSX</Button></center>
                </Jumbotron>
                <div class="paginationEvents">{this.renderPagination()}</div>
                <AssetChange
                    assetTitle={this.state.assetsTitle}
                    updateAssetVisible={this.state.updateAssetVisible}
                    hideUpdateAsset={this.hideUpdateAsset}
                    handleUpdateAssetChange={this.handleUpdateAssetChange}
                    handleUpdateColourChange={this.handleUpdateColourChange}
                    asset={this.state.updateAsset} />

                <AssetItemList accessLevel={this.props.accessLevel} reloadAssets={this.reloadAssets} showUpdateAsset={this.showUpdateAsset} ref="assetlist"/>
                </div>)
        }
    }
}

export default AssetsPage;
